import { useEffect, useState } from 'react';
import { APP_NAME, APP_SLOGAN } from '../../config';

interface SplashScreenProps {
  onComplete: () => void;
}

export default function SplashScreen({ onComplete }: SplashScreenProps) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onComplete, 300);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 bg-gradient-to-br from-[#1a56db] to-[#2563eb] flex flex-col items-center justify-center z-[9999] transition-opacity duration-300 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center animate-fade-in">
        {/* Logo */}
        <div className="mb-6 relative group">
          <div className="absolute inset-0 bg-white/30 rounded-full blur-xl transform group-hover:scale-110 transition-transform duration-500"></div>
          <img 
            src="/logo.svg" 
            alt={APP_NAME} 
            className="w-28 h-28 relative z-10 drop-shadow-2xl rounded-full shadow-white/10"
          />
        </div>

        {/* App Name */}
        <h1 className="text-white text-4xl font-bold mb-3 tracking-wide drop-shadow-md">{APP_NAME}</h1>
        <p className="text-blue-100 text-base font-medium tracking-widest uppercase opacity-90">{APP_SLOGAN}</p>

        {/* Loading Animation */}
        <div className="mt-10 flex gap-3">
          <div className="w-2.5 h-2.5 bg-white rounded-full animate-bounce shadow-lg" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2.5 h-2.5 bg-white rounded-full animate-bounce shadow-lg" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2.5 h-2.5 bg-white rounded-full animate-bounce shadow-lg" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}
